<template>
  <div class="i-team-multi-picker">

    <i-multi-picker
      :label-counter="$t('common.teamFoldersCount')"
      :label="resolvedLabel"
      :placeholder="resolvedPlaceholder"
      :value="value"
      :fetch-options="fetchSharedFolders"
      option-label="name"
      option-value="id"
      @input="$val => $emit('input',$val)"
    />
  </div>
</template>

<script>
import {listSharedFolders} from "@/services/api/dropbox/recovery/shared-folder/sharedFolder";
import IMultiPicker from "@/components/common/forms/IMultiPicker";

export default {
  name: 'ISharedFolderMultiPicker',
  components: {IMultiPicker},
  props: {
    value: {},
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
  },

  computed: {
    resolvedLabel() {
      return this.label || this.$t('common.teamFolder');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('recovery.search.placeholders.searchAllTeamFolders');
    }
  },

  data() {
    return {
      selected: null,
      sharedFolders: []
    }
  },

  methods: {
    fetchSharedFolders({search}) {

      return listSharedFolders({
        pagination: {
          pageNumber: 1,
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result}) => {
          return result
        })
    },
  },

}
</script>

<style lang="scss">
@import "IUserMultiPicker.scss";
</style>
